import { render, staticRenderFns } from "./AddVat.vue?vue&type=template&id=1d28de11&"
import script from "./AddVat.vue?vue&type=script&lang=js&"
export * from "./AddVat.vue?vue&type=script&lang=js&"
import style0 from "./AddVat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports